import React from 'react';
import { allGroupValue } from '@teetsh/app/src/containers/CarnetsDeNotes/Evaluations/constants';
import ButtonsRadioMultiple from '@teetsh/app/src/components/Form/ButtonsRadioMultiple';
import { Checkboxes } from '@teetsh/app/src/components/Form/Checkboxes';
import FormGroup from '@teetsh/app/src/components/Form/FormGroup';
import { hasEnoughSpaceForAllLabels } from 'utils/formUtils';
import { useTranslation } from 'react-i18next';

interface Props {
  options: string[];
  value: string[];
  onChange: (value: string[]) => void;
}

export function GroupElevesPicker(props: Props) {
  const { value, onChange, options } = props;
  const { t } = useTranslation(['carnet']);
  if (options.length <= 1) {
    return null;
  }

  if (!hasEnoughSpaceForAllLabels(options)) {
    return (
      <FormGroup label={t('carnet:carnetDetails.sidebar.elevesGroup')}>
        <Checkboxes
          condensed
          value={value}
          onChange={v => {
            if (v.includes(allGroupValue) && !value.includes(allGroupValue)) {
              return onChange([allGroupValue]);
            }
            return onChange(v.filter(g => g !== allGroupValue));
          }}
          options={[
            ...options.map(v => ({
              label: v,
              value: v,
            })),
            {
              label: t('carnet:carnetDetails.sidebar.elevesGroupAll'),
              value: allGroupValue,
            },
          ]}
        />
      </FormGroup>
    );
  }

  return (
    <ButtonsRadioMultiple<string>
      label={t('carnet:carnetDetails.sidebar.elevesGroup')}
      fill
      value={value}
      canBeEmpty={false}
      onChange={v => {
        if (v.includes(allGroupValue) && !value.includes(allGroupValue)) {
          return onChange([allGroupValue]);
        }
        return onChange(v.filter(g => g !== allGroupValue));
      }}
      options={[
        ...options.map(v => ({
          label: v,
          value: v,
        })),
        {
          label: t('carnet:carnetDetails.sidebar.elevesGroupAll'),
          value: allGroupValue,
        },
      ]}
    />
  );
}
